import React, {useEffect, useRef} from "react";
import {connect} from "react-redux";
import Modal from "@components/modal";
import {getRules} from "@actions/rulesAction";
import ElementLoading from "@components/elemetLoading";
import {ModalCloseIcon} from "../resource";

function Rules({rules, show, handleCancel, getRules}) {
    const rulesBlock = useRef();
    useEffect(() => {
        if (show) {
            getRules()
        }
    }, [show])

    useEffect(() => {
        if (rules) {
            rulesBlock.current.innerHTML = rules.text;
        }

    }, [rules])
    return(
        <Modal show={show}
               handleCancel={() => handleCancel(false)}
               parentClass={"rules"}
        >
            <div className="modal-header">
                <div className="modal-header-title">{rules.title || ""}</div>
                <div className="modal-header-control">
                    <button className="circled-button small" onClick={() => handleCancel(false)}>
                        <ModalCloseIcon id="Rules"/>
                    </button>
                </div>
            </div>
            <div ref={rulesBlock} className="modal-body scrollable">
                <ElementLoading />
            </div>

        </Modal>
    )
}

const mapStateToProps = (state) => {
    return {
        rules: state.rules
    }
}

const mapDispatchToProps = {
    getRules
}

export default connect(mapStateToProps, mapDispatchToProps)(Rules)